module.exports = __webpack_public_path__ + "static/img/QRCodes.a3d7b31.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/QRCodes.png
// module id = pFcD
// module chunks = 3